<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <b-form-input
          autofocus
          size="sm"
          v-model="searchParams.text"
          v-debounce:400="handleTextInput"
          debounce-events="input"
        />
      </div>
      <div>
        <button class="btn btn-primary btn-sm" @click="select(1)">
          Pesquisa
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table-paginator
          :data="products"
          @pagechange="select($event)"
        >
          <table class="customTable table table-hover">
            <template v-for="(product, index) in products.data">
              <tr :key="index" @click="handleAddProduct(product)">
                <td>
                  {{ product.description }}
                  <small class="text-muted"> #{{ product.base_sku_id }}</small>
                </td>
                <td class="text-right">
						      {{ product.product_variant[0].price | decimal }}
					      </td>
              </tr>
            </template>
          </table>
        </table-paginator>
      </div>
    </div>
  </div>
</template>

<script>

import tablePaginator from "@/components/sections/TablePaginator";

export default {
  components : { tablePaginator },

  data: () => ({
    products: {},

    searchParams: {
      text: null,
      page : 1,
      status: 1,
    },
  }),

  methods: {

    async select(page = 1) {
      this.searchParams.page = page;

      this.$store.commit("showLoading");

      let response = await this.$store.dispatch(
        "products/getProducts",
        this.searchParams
      );

      this.products = response.products;

      this.$store.commit("hideLoading");
    },

    handleAddProduct(product) {
      console.log(product)
      // this.$store.commit("drawer/selectedShift", shift);
      this.$store.commit("orderForm/increaseProduct", { product : product, quantity : 1})
    },

    handleTextInput() {
      this.select(1)
    }
  },
};
</script>

<style>
</style>